<template>
  <section id="about" class="about section">
    <div class="about-shell reveal-up">
      <h2>Game design led by its founder.</h2>
      <p>
        The studio develops each game in-house, with artists joining project by project to create its visuals, music, and effects.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutSection'
};
</script>
  